import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import Loader from "src/shared/Loader";

import classes from "./PersonDetail.module.css";

import { AboutPerson } from "src/types/aboutPerson";

import { dateFormat } from "src/utility";
import { getPersonDetail } from "src/shared/api";

const PersonDetail = () => {
  const [data, setData] = useState<AboutPerson | null>(null);
  let { id } = useParams();

  useEffect(() => {
    getPersonDetail(id).then((response) => setData(response.data));
  }, [id]);

  if (!data) {
    return <Loader />;
  }

  return (
    <div className={classes.personaInfo}>
      <div className={classes.imageInfoDetail}>
        <img
          className={classes.personImage}
          alt="person"
          src={`https://image.tmdb.org/t/p/w500${data.profile_path}`}
          height={200}
        />
        <div className={classes.personBioData}>
          <h1 className={classes.personaName}>{data.name}</h1>
          <span>
            <b>Birthday:</b> {dateFormat(data.birthday)}
          </span>
          <span>
            <b>Birth place:</b> {data.place_of_birth}
          </span>
          <span>
            <b>Profession:</b> {data.known_for_department}
          </span>
        </div>
      </div>
      <p className={classes.bio}>{data.biography}</p>
    </div>
  );
};

export default PersonDetail;
